import { Head, useForm } from '@inertiajs/react'
import { Mail, Send } from 'lucide-react'

import { AppShell } from '@/layouts/AppShell'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { FieldError } from '@/components/feedback/FieldError'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'

type PasswordResetRequestFormProps = {
  title: string
  description: string
  postPath: string
  loginPath: string
}

export function PasswordResetRequestForm({
  title,
  description,
  postPath,
  loginPath,
}: PasswordResetRequestFormProps) {
  const { data, setData, post, processing, errors, transform } = useForm({
    email: '',
  })

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((current) => ({ password_reset: current }))
    post(postPath)
  }

  return (
    <AppShell>
      <Head title={title} />
      <Card padding="lg" className="mx-auto w-full max-w-md space-y-8">
        <header className="space-y-2 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500/20 text-brand-100">
            <Mail className="h-5 w-5" />
          </div>
          <h1 className="text-2xl font-semibold text-white">{title}</h1>
          <p className="text-sm text-white/60">{description}</p>
        </header>

        <form onSubmit={submit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email">メールアドレス</Label>
            <Input
              id="email"
              type="email"
              value={data.email}
              onChange={(event) => setData('email', event.target.value)}
              placeholder="user@example.com"
              autoComplete="email"
              required
            />
            <FieldError message={errors.email} />
          </div>

          <Button type="submit" className="w-full" loading={processing}>
            <Send className="h-4 w-4" />
            再設定メールを送信
          </Button>
        </form>

        <p className="text-center text-xs text-white/50">
          <a href={loginPath} className="font-semibold text-brand-200 hover:text-brand-100">
            ログイン画面に戻る
          </a>
        </p>
      </Card>
    </AppShell>
  )
}
